/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

function reloadUpsellContainer() {
  const wrapper = document.querySelector('.cm-cart-drawer-left');
  if (!wrapper) return;

  fetch(window.location.href)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('.cm-cart-drawer-left');
      if (newDrawer) wrapper.innerHTML = newDrawer.innerHTML;
    });
}

// Lyt når cart drawer åbnes
document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.querySelector('#site-cart-sidebar');
  if (!drawer) return;

  const observer = new MutationObserver(() => {
    const container = drawer.querySelector('.cm-cart-drawer-left');
    if (container) {
      reloadUpsellContainer();
    }
  });

  observer.observe(drawer, { childList: true, subtree: true });
});

document.addEventListener("click", function (e) {
  const btn = e.target.closest("[data-cart-drawer-close]");
  if (!btn) return;

  const drawer = document.querySelector("cart-drawer");
  if (drawer && typeof drawer.closeCartDrawer === "function") {
    drawer.closeCartDrawer();
  }
});

  document.addEventListener('shopify:section:load', function (event) {
  if (event.detail?.sectionId === 'cart-drawer') {
    insertMobileCloseButton(); // ← din funktion
  }
});




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
